import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useLogger } from 'hooks/useLogger/useLogger';
import { getEndUserInfo, PaymentModel } from 'services/user';

interface UseUserInfoProps {
  patientCognitoId: string;
}

export function useUserInfo({ patientCognitoId }: UseUserInfoProps) {
  const log = useLogger();

  const { data: userInfo } = useQuery(
    ['endUserInfo', patientCognitoId],
    () => getEndUserInfo(patientCognitoId),
    {
      onError: e => log.error('Error fetching user info', { e }),
    },
  );

  const isSubscriptionModel = useMemo(
    () => userInfo?.data?.payment_model === PaymentModel.SUBSCRIPTION,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userInfo?.data?.payment_model],
  );

  return { userInfo, isSubscriptionModel };
}
